import { dealDamage, addModifier } from '../player.type';
import type { Die } from '../die.type';
import type { Technique, Requirement } from '../techniques.type';
import type { Player } from '../player.type';
import { StatusEffect } from '../status-effects.type';
import { DieFace } from '../face.type';
import { SoundType } from '../../components/audio.svelte';

export const pincer: Technique[] = [
  {
    ingredients: [DieFace.Pincer],
    title: 'Nip',
    text: 'Apply 1 Vulnerable.',
    tags: ['debuff'],
    audio: SoundType.AttackBlunt,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(target, StatusEffect.Vulnerable, 1);
    },
  },
  {
    ingredients: [DieFace.Pincer, DieFace.Pincer],
    title: 'Pinch',
    text: 'Deal 2 Damage, Apply 1 vulnerable.',
    tags: ['damage', 'debuff'],
    audio: SoundType.AttackBlunt,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 2, target, source, dice });
      addModifier(target, StatusEffect.Vulnerable, 1);
    },
  },
  {
    ingredients: [DieFace.Pincer, DieFace.Pincer, DieFace.Pincer],
    title: 'Clamp',
    text: 'Deal 3 Damage, Apply 2 vulnerable.',
    tags: ['damage', 'debuff'],
    audio: SoundType.AttackBlunt,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 3, target, source, dice });
      addModifier(target, StatusEffect.Vulnerable, 2);
    },
  },
  {
    ingredients: [DieFace.Pincer, DieFace.Poison],
    title: 'Grab and Stab',
    text: 'Apply 1 Snared and 3 Poison.',
    tags: ['debuff'],
    audio: SoundType.AttackPierce,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(target, StatusEffect.Snared, 1);
      addModifier(target, StatusEffect.Poison, 3);
    },
  },
  {
    ingredients: [DieFace.Pincer, DieFace.Shell],
    title: 'Claw Slam',
    text: 'Deal 2 Damage, Apply 1 Dopey.',
    tags: ['damage', 'debuff'],
    audio: SoundType.AttackBlunt,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 2, target, source, dice });
      addModifier(target, StatusEffect.Dopey, 1);
    },
  },
];
